const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/sandboxes/$id/changelog.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getQueryClient } from "@/lib/client";
import { generateSandboxMeta } from "@/lib/generate-sandbox-meta";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
interface ChangelogResponse {
  hits: (OfferHit | ItemHit | AssetHit | Hit)[];
  query: string;
  processingTimeMs: number;
  limit: number;
  offset: number;
  estimatedTotalHits: number;
}
interface DefaultHit {
  _id: string;
  timestamp: string;
  metadata: Metadata;
}
interface Metadata {
  changes: Change[];
  contextId: string;
  contextType: string;
}
interface Change {
  changeType: "insert" | "update" | "delete";
  field: string;
  newValue: unknown;
  oldValue: unknown;
}
interface OfferHit extends DefaultHit {
  metadata: Metadata & {
    contextType: "offer";
  };
  document: SingleOffer;
}
interface ItemHit extends DefaultHit {
  metadata: Metadata & {
    contextType: "item";
  };
  document: SingleItem;
}
interface AssetHit extends DefaultHit {
  metadata: Metadata & {
    contextType: "asset";
  };
  document: SingleItem;
}
interface Hit {
  _id: string;
  timestamp: string;
  metadata: Metadata;
  document: null;
}
export const Route = createFileRoute("/{-$locale}/sandboxes/$id/changelog")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      queryClient
    } = context;
    await queryClient.prefetchQuery({
      queryKey: ["changelog", {
        id: params.id,
        page: 1,
        limit: 20
      }],
      queryFn: () => httpClient.get<ChangelogResponse>(`/sandboxes/${params.id}/changelog`, {
        params: {
          page: 1,
          limit: 20
        }
      })
    });
    return {
      params,
      dehydratedState: dehydrate(queryClient)
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("sandboxes.notFoundTitle"),
          description: i18n.t("sandboxes.notFoundDescription")
        }]
      };
    }
    const {
      id
    } = params;
    const sandbox = getFetchedQuery<SingleSandbox>(queryClient, ctx.loaderData?.dehydratedState, ["sandbox", {
      id
    }]);
    const offer = getFetchedQuery<SingleOffer>(queryClient, ctx.loaderData?.dehydratedState, ["sandbox", "base-game", {
      id
    }]);
    if (!sandbox) return {
      meta: [{
        title: i18n.t("sandboxes.notFoundTitle"),
        description: i18n.t("sandboxes.notFoundDescription")
      }]
    };
    return {
      meta: generateSandboxMeta(sandbox, offer, i18n.t("sandboxes.metaChangelogTitle"))
    };
  }
});